import { toIndoFormat } from "../../utils/helper"
import { ContractPhoto, buildContractPhoto } from "./ContractPhoto"
import { LineItem } from "./LineItem"

const SKU_PALM_FRUIT_NIAGA_PRIMARY_BUYER_CONTRACT = "PALM_0003"
const SKU_PALM_FRUIT_NIAGA_PRIMARY_TAXABLE_BUYER_CONTRACT = "PALM_0005"


export class SaleStatement {
    id: number
    state?: string
    status?: string
    total?: number
    pre_tax_total?: number
    tax_total?: number
    line_items?: LineItem[]
    photos?: ContractPhoto[]

    getBuyerLineItemBySku(): LineItem[] | undefined {
        const lineItem = this.line_items?.filter(li => li.sku === SKU_PALM_FRUIT_NIAGA_PRIMARY_BUYER_CONTRACT || li.sku === SKU_PALM_FRUIT_NIAGA_PRIMARY_TAXABLE_BUYER_CONTRACT)
        if ((lineItem?.length ?? 0) > 0) {
            return lineItem
        }
        return undefined
    }

    getTotal(): number|undefined {
        return this.total
    }

    getPreTaxTotal(): number|undefined {
        return this.pre_tax_total
    }

    getTaxTotal(): number|undefined {
        return this.tax_total
    }

    getQuantity(): number|undefined {
        const lineItem = this.getBuyerLineItemBySku()
        if (lineItem) {
            return lineItem.reduce(((value, item) => value + (item.quantity ?? 0)), 0)
        }
        return undefined
    }

    getPricePerUnit(): string|undefined {
        const lineItem = this.getBuyerLineItemBySku()
        if (lineItem && this.getQuantity()) {
            return toIndoFormat((this.getTotal() ?? 0) / this.getQuantity()!)
        }
        return undefined
    }

    constructor(id: number, state?: string, status?: string, total?: number, lineItems?: LineItem[], photos?: ContractPhoto[], pre_tax_total?: number, tax_total?: number) {
        this.id = id
        this.state = state
        this.status = status
        this.total = total
        // this.payments = payments
        this.line_items = lineItems
        this.photos = photos
        this.pre_tax_total = pre_tax_total
        this.tax_total = tax_total
    }

    static buildForName(ss: any): SaleStatement {
        return new SaleStatement(
            ss.id,
            ss.state,
            ss.status,
            ss.total ?? ss.total_amount,
            ss.line_items?.map((item: any) => LineItem.buildLineItem(item)),
            // ss.payments?.map((p:any) => buildPaymentForContractDetail(p)),
            ss.photos?.map((p:any) => buildContractPhoto(p)),
            ss.pre_tax_total,
            ss.tax_total
        )
    }
}

export function buildSaleStatement(ss: any): SaleStatement {
    console.log(ss)
    return new SaleStatement(
        ss.id,
        ss.state,
        ss.status,
        ss.total ?? ss.total_amount,
        ss.line_items?.map((item: any) => LineItem.buildLineItem(item)),
        // ss.payments?.map((p:any) => buildPaymentForContractDetail(p)),
        ss.photos?.map((p:any) => buildContractPhoto(p.photo)),
        ss.pre_tax_total,
        ss.tax_total
    )
}